import { Link } from '@mui/material';
import { Fragment, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';

import { merchantPayinRequestsApi, merchantPayoutRequestsApi } from 'api';
import { DescriptionRow } from 'components';
import { OrderType, QueryKey } from 'enums';
import { TranslationNamespace } from 'i18n';

import { MerchantRequestsDialog } from './MerchantRequestsDialog';

type Props = {
  orderId: string;
  orderType: OrderType;
};

export const MerchantRequests: React.FC<Props> = ({ orderId, orderType }) => {
  const { t } = useTranslation(TranslationNamespace.Common, {
    keyPrefix: 'features.orders.merchant_requests',
  });
  const { t: tCommon } = useTranslation(TranslationNamespace.Common);

  const [dialogOpen, setDialogOpen] = useState(false);
  const queryKey = useMemo(
    () =>
      orderType === OrderType.Payin
        ? QueryKey.MerchantPayinRequests
        : QueryKey.MerchantPayoutRequests,
    [orderType],
  );
  const queryFn = useMemo(
    () =>
      orderType === OrderType.Payin
        ? merchantPayinRequestsApi.getForOrder
        : merchantPayoutRequestsApi.getForOrder,
    [orderType],
  );

  const queryResult = useQuery([queryKey, orderId], queryFn(orderId), {
    enabled: dialogOpen,
  });

  return (
    <Fragment>
      <DescriptionRow
        title={t('title')}
        value={
          <div>
            <Link
              component="button"
              variant="body2"
              underline="none"
              onClick={() => setDialogOpen(true)}
            >
              {tCommon('buttons.open')}
            </Link>
          </div>
        }
      />
      <MerchantRequestsDialog
        queryResult={queryResult}
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
      />
    </Fragment>
  );
};
